import CustomMDEditor from "../../../../components/CustomMDEditor";


const ProductMDEditor = props => {
    const setValue = value => props.setFieldValue(props.fieldName, value);
    return <CustomMDEditor value={props.formValues[props.fieldName]} onChange={setValue}/>;
}

export default ProductMDEditor;